import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { NavLink, Redirect } from 'react-router-dom';

//Indico el tamaño de la ventanada cuando se abre para ver el menú
const drawerWidth = 300;
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    //Indico que distancia dejo hacia abajo luego de la barra
    padding: theme.spacing(0),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export default function PersistentDrawerLeft() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const [linkFuncionarioPersonal, setLinkFuncionarioPersonal] = React.useState(['./MantArchivo', './Consultas', './ControlAsistencia', './Informes', './Actividades-pendientes']);
    const [linkJefes, setLinkJefes] = React.useState(['./Informes', './Actividades-pendientes', './Calificaciones']);
    const [linkFuncionarios, setlinkFuncionarios] = React.useState(['./Consultas', './Informes', './Calificaciones']);
    const [linkJefeFinal, setlinkJefeFinal] = React.useState(['./Informes']);
    const [linkVacacional, setlinkVacacional] = React.useState(['./Informes']);

    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar position="fixed" open={open}>
                <Toolbar>
                    <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={{ mr: 2, ...(open && { display: 'none' }) }}
                    >
                    <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                    {/*CHLA-EP*/}
                    <a href="./inicio" style={{color: 'white'}}>CHLA-EP</a>
                    </Typography>
                    {sessionStorage.login ? <NavLink style={{position: 'fixed', right: 50}} to='/personal-app/login' className="btn btn-dark mr-2">Logout</NavLink> : <NavLink style={{position: 'fixed', right: 50}} to='/personal-app/login' className="btn btn-dark mr-2">Login</NavLink> }
                </Toolbar>
                </AppBar>
                <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}>
                <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                    {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                {sessionStorage.login
                ?
                    sessionStorage.tipoUsuario === '4'
                    ?
                        <List>
                        {['Mantenimiento de archivos', 'Consultas', 'Control Asistencia', 'Informes', 'Actividades Pendientes'].map((text, index) => (
                            <ListItem key={text} disablePadding>
                                <ListItemButton href={linkFuncionarioPersonal[index]}>
                                <ListItemText primary={text}/>
                                </ListItemButton>
                            </ListItem>
                            ))}
                        </List>
                    :
                        sessionStorage.tipoUsuario === '3'
                        ?
                            <List>
                            {['Solicitudes Pendientes', 'Actividades Pendientes', 'Calificaciones'].map((text, index) => (
                                <ListItem key={text} disablePadding>
                                    <ListItemButton href={linkJefes[index]}>
                                    <ListItemText primary={text}/>
                                    </ListItemButton>
                                </ListItem>
                                ))}
                            </List>
                        :
                            sessionStorage.tipoUsuario === '2'
                            ?
                                <List>
                                {['Consultas', 'Solicitudes', 'Calificaciones'].map((text, index) => (
                                    <ListItem key={text} disablePadding>
                                        <ListItemButton href={linkFuncionarios[index]}>
                                        <ListItemText primary={text}/>
                                        </ListItemButton>
                                    </ListItem>
                                    ))}
                                </List>
                            :
                                sessionStorage.tipoUsuario === '5'
                                ?
                                    <List>
                                    {['Solicitudes Pedientes'].map((text, index) => (
                                        <ListItem key={text} disablePadding>
                                            <ListItemButton href={linkJefeFinal[index]}>
                                            <ListItemText primary={text}/>
                                            </ListItemButton>
                                        </ListItem>
                                        ))}
                                    </List>
                                :
                                    sessionStorage.tipoUsuario === '6'
                                    ?
                                        <List>
                                        {['Solicitudes Pedientes'].map((text, index) => (
                                            <ListItem key={text} disablePadding>
                                                <ListItemButton href={linkVacacional[index]}>
                                                <ListItemText primary={text}/>
                                                </ListItemButton>
                                            </ListItem>
                                            ))}
                                        </List>
                                    :
                                        null
                : 
                    null
                }
                <Divider />
                </Drawer>
                <Main open={open}>
                <DrawerHeader />
                </Main>
            </Box>
        </>
    );   
}
